module.exports = __webpack_public_path__ + "img/img04_text.ac2402cd.png";